<template>
  <div
    v-if="visible"
    class="alert alert-warning d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3"
    role="status"
  >
    <div class="d-flex align-items-start gap-2">
      <i class="ti ti-alert-circle fs-20 mt-1"></i>
      <div>
        <strong class="d-block">Complete your onboarding</strong>
        <span class="small">{{ message }}</span>
      </div>
    </div>
    <router-link
      to="/dashboard/my-documents"
      class="btn btn-dark btn-sm flex-shrink-0"
    >
      Go to Documents
    </router-link>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import employeeDocumentService from "@/services/hrm/employeeDocumentService";

const summary = ref(null);
const loaded = ref(false);

const visible = computed(
  () => loaded.value && summary.value && summary.value.employee_complete !== true,
);

const message = computed(() => {
  const s = summary.value;
  if (!s) return "";
  const parts = [];
  if (s.contract_status === "waiting") {
    parts.push("Sign your employment contract");
  }
  const pending = Number(s.documents_pending || 0);
  if (pending > 0) {
    parts.push(
      pending === 1
        ? "Upload 1 requested document"
        : `Upload ${pending} requested documents`,
    );
  }
  if (s.employee_tasks_pending > 0 && parts.length === 0) {
    return `${s.employee_tasks_pending} task(s) still need your attention.`;
  }
  return parts.length ? `${parts.join(" and ")}.` : "Finish the items on your Documents page.";
});

onMounted(async () => {
  try {
    const { data } = await employeeDocumentService.mine();
    summary.value = data?.onboarding_summary || null;
  } catch {
    summary.value = null;
  } finally {
    loaded.value = true;
  }
});
</script>
